import React from "react";
import { Input, List, Typography } from "antd";
import { UnorderedListOutlined } from "@ant-design/icons";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { onlyNumbers } from "Helpers/onlyNumbers";
import { getAllWorksToSelect } from "Api/WorksApi/helpers";
import { useSelector } from "react-redux";
import { selectProject } from "AppStore/Slices/ProjectSlice/ProjectSlice";
import MyTagComment from "Components/MyTagComment/MyTagComment";
const { Title } = Typography;
const { TextArea } = Input;

export const ChooseWorks = ({
  onChange,
  selectedWorks = [],
  changeValue,
  changeComment = () => {},
  disabled = false,
  fetchFunction = getAllWorksToSelect,
  projectId = "",
  size = "",
  title = "Додати роботи",
  placeholder = "Пошук робіт...",
  findMaterials = false,
}) => {
  const { currentProjectId } = useSelector(selectProject);

  return (
    <>
      <div style={{ flex: 1, paddingBottom: "10px" }}>
        <Title level={5}>{title}</Title>

        <SearchSelectDebounce
          size={size}
          disabled={disabled}
          mode="multiple"
          prefix={<UnorderedListOutlined />}
          placeholder={placeholder}
          customFetch={(e) => fetchFunction(e, projectId || currentProjectId)}
          onChange={(e) => {
            const worksIds = (Array.isArray(e) ? e : [])
              .filter(Boolean)
              .map((el) => el?.value ?? el)
              .filter(Boolean);
            const dataValues = worksIds.map((work) => {
              const json = work.split("___")[0];
              const raw = JSON.parse(json);
              return raw;
            });
            const valuesToInsert = Object.values(
              dataValues.reduce((acc, el) => {
                const key = el.allowedWorkTypeId || el.id;

                if (!acc[key]) {
                  acc[key] = el;
                  return acc;
                }

                if (Number(acc[key].value) === 0 && Number(el.value) !== 0) {
                  acc[key] = el;
                }

                return acc;
              }, {}),
            );
            onChange(valuesToInsert);
          }}
          value={selectedWorks.map((e) => {
            if (findMaterials) {
              return {
                value: JSON.stringify(e) + `___` + e.id,
                // label: e.value
                // ? `${e.dateArrived}. ${e.nomenclature}. Залишок: ${e.restCountIfBlankChecked || e.restCountAfterChanges} ${e.unit}`
                // : `${e.dateArrived}. ${e.nomenclature}. Залишок: ${e.restCountAfterChanges} ${e.unit}`,
                label: `${e.dateArrived}. ${e.nomenclature}. Залишок: ${e.restCountAfterChanges} ${e.unit}`,
              };
            } else {
              return {
                value: JSON.stringify(e) + `___` + e.allowedWorkTypeId,
                label: e.code + " " + e.title + ", " + e.unit,
              };
            }
          })}
        />
      </div>

      {selectedWorks.length ? (
        <List
          style={{ marginTop: 18 }}
          dataSource={selectedWorks}
          renderItem={(item) => (
            <List.Item>
              <MyTagComment
                item={item}
                changeComment={changeComment}
                disabled={disabled}
              >
                {findMaterials ? (
                  <TextArea
                    style={{
                      backgroundColor: "var(--main-custom-input-bg-color)",
                      resize: "none",
                    }}
                    disabled={disabled}
                    autoSize={{ minRows: 1, maxRows: 15 }}
                    value={`${item?.dateArrived}. ${item?.nomenclature}. Залишок ${item?.restCountAfterChanges} ${item?.unit}`}
                    readOnly
                  />
                ) : (
                  <TextArea
                    style={{
                      backgroundColor: "var(--main-custom-input-bg-color)",
                      resize: "none",
                    }}
                    autoSize={{ minRows: 1, maxRows: 15 }}
                    value={`${item?.code}. ${item?.title}, ${item?.unit}`}
                    disabled={disabled}
                    readOnly
                  />
                )}

                <Input
                  onClick={(e) => e.stopPropagation()}
                  onFocus={(e) => e.stopPropagation()}
                  disabled={disabled}
                  placeholder="Значення"
                  style={{ width: 65 }}
                  value={item?.value}
                  onChange={(e) => {
                    const val = onlyNumbers(e.target.value);
                    /////
                    /////
                    /////
                    /////
                    /////test
                    /////
                    /////
                    /////
                    //////////
                    /////
                    /////
                    //////////
                    /////
                    /////
                    /////
                    if (findMaterials) {
                      changeValue({
                        id: item.id,
                        value: val ? Number(val) : 0,
                      });
                    } else {
                      changeValue({
                        allowedWorkTypeId: item.allowedWorkTypeId,
                        // value: val ? Number(val) : 0,
                        value: val || "0",
                      });
                    }
                  }}
                />
              </MyTagComment>
            </List.Item>
          )}
        />
      ) : (
        ""
      )}
    </>
  );
};
